module.exports = __webpack_public_path__ + "static/img/lb-1.8478fa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/lb-1.jpg
// module id = AUv3
// module chunks = 0